const state = {
  projectId: sessionStorage.getItem('projectId')||0,
  groupCode:sessionStorage.getItem('groupCode')||0,
  projectLogo: 0,
};

// getters
const getters = {
  getId:state=>{
    return state.projectId
  },
  getCode:state=>{
    return state.groupCode
  },
  getLogo:state=>{
    return state.projectLogo
  },
};

// actions
const actions = {
  setId({ commit },str){
    commit('changeId',str);
    sessionStorage.setItem('projectId',str)
  },
  setCode({ commit },str){
    commit('changeCode',str);
    sessionStorage.setItem('groupCode',str)
  },
  setLogo({ commit },str){
    commit('changeLogo',str);
  },
};

// mutations
const mutations = {
  changeId(state,str){
    state.projectId=str;
  },
  changeCode(state,str){
    state.groupCode=str;
  },
  changeLogo(state,str){
    state.projectLogo=str;
  },
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/comm/store/modules/cookies.js